// import { createSelector } from 'reselect'

const getJobOffersState = (state) => state.jobOffers
const getJobOffers = (state) => state.jobOffers.data

export default {
  getJobOffers,
  getJobOffersState
}
